var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-bg bg-gray-400"}),_c('div',{staticClass:"loader-bar",style:({ width: (_vm.progress + "%") })})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }